export const ROLES = {
  developer: 'developer',
  administrator: 'administrator',
  member: 'member'
};